import VueRouter from "vue-router";

import Home from "@/views/Home";
import Maratona from "@/views/Maratona";
import Submissoes from "@/views/Submissoes";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  }, {
    path: "/maratona",
    name: "maratona",
    component: Maratona,
  }, {
    path: "/submissoes",
    name: "submissoes",
    component: Submissoes,
  }  

];

const router = new VueRouter({
  routes, // short for `routes: routes`
  /* mode: "history", */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

export default router;
